
export enum Insurer {
    Uniqa = 1,
    Kooperativa = 2,
    Allianz = 3,
    Generali = 4,
    CPP = 5,
    GeneraliCeskaPojistovna = 6,
    Direct = 7,
    Csob = 8,
    Axa = 9,
    Slavia = 10,
    HvP = 11,
    PVZP = 12,
    Fortegra = 13,
    Pillow = 14,
    EuropAssistance = 15,
    Colonnade = 16,
    Das = 18,
    Custom = 19
}

export interface IOfferCompany {
    id: number
    name: string
}